module.exports = __webpack_public_path__ + "img/none.f1a2c3c0.png";